<div class="page-content-wrapper" [ngClass]="{'is-search-dialog': isDialog, 'widget-mode': widgetMode}">
  <!-- Widget mode: Read-only grid (no filters/settings, only sorting) -->
  @if (widgetMode) {
    <ng-container *ngTemplateOutlet="gridContent"></ng-container>
  } @else {
    <app-sidebar-layout [showMenuToggle]="showMenuToggle" [isDialog]="isDialog" [fillHeight]="!isDialog"
      [ngClass]="{'not-allowed': !canRead}">
      <div class="table-header" [ngClass]="{'disabled-content': !canRead}">
        @if (!isDialog) {
          <div class="card-main-title">
            <app-tab-main [selectedIndex]="selectedTabIndex" [links]="tabs"></app-tab-main>
          </div>
        }
        <div class="table-actions">
          <div class="search-input-div search-input-container">
            <div class="input-group">
              <button type="submit" class="input-group-addon">
                <label class="label-icon" for="search">
                  <i class="material-icons mb-0">search</i>
                </label>
              </button>
              <div class="input-field">
                <input type="search" #searchField class="search-input mb-0"
                  placeholder="{{ searchPlaceholder | translate }}" />
                </div>
              </div>
            </div>
            @if (canCreate && !addDisabled && !isDialog) {
              <div
                class="create-entity">
                <button type="button" class="btn" (click)="openEntityDialog()">
                  <span>{{'Create' | translate}} {{ addEntityTitle | translate}}</span>
                </button>
              </div>
            }
            @if (additionalButtons?.length && !isDialog && !widgetMode) {
              @for (item of additionalButtons; track trackByIndex($index)) {
                <div class="create-entity">
                  <button type="button" class="btn" [ngClass]="item.class"
                    [disabled]="item.readonly" (click)="item.onClick()"><span>{{ item.title | translate:item.titleParams}}</span>
                  </button>
                </div>
              }
            }
          </div>
          @if (isDialog) {
            <div class="d-flex dialog-buttons">
              @if (searchFieldData?.isMultiple) {
                <button
                  (click)="closeSearch(searchFieldData.selected, selectedSearchItems)"
                class="btn modal-footer-btn save-modal-btn">{{"Add Selected" | translate}}</button>
              }
              <button class="btn modal-footer-btn cancel-modal-btn" (click)="closeSearch(false)">{{"Cancel" |
              translate}}</button>
            </div>
          }
        </div>
        <!-- Batch action toolbar: shown when 1+ rows are selected -->
        @if (selectedRowsCount > 0 && !isDialog && !widgetMode) {
          <div class="batch-action-toolbar">
            <div class="batch-info" (click)="clearRowSelection()" [title]="'Clear selection' | translate">
              <mat-icon class="batch-checkbox-icon">check_box</mat-icon>
              <span class="batch-count">{{ '{{count}} {{label}} selected' | translate: { count: selectedRowsCount, label: (selectedItemsLabel | translate) } }}</span>
            </div>
            <div class="batch-actions">
              @for (action of batchActions; track trackByIndex($index)) {
                @if (!action.hidden) {
                  @if (action.menuItems?.length) {
                    <button type="button" class="batch-action-btn" [ngClass]="action.class"
                      [disabled]="action.disabled" [matMenuTriggerFor]="actionMenu">
                      @if (action.matIcon) {
                        <mat-icon>{{ action.matIcon }}</mat-icon>
                      }
                      @if (action.iconClass) {
                        <i [class]="action.iconClass"></i>
                      }
                      <span>{{ action.label | translate }}</span>
                      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu" [class]="'batch-status-menu ' + (action?.class || '')" panelClass="batch-status-menu-panel">
                      @for (item of action.menuItems; track item) {
                        <button mat-menu-item (click)="item.onClick(item.value)">
                          <span class="status-badge" [ngStyle]="{'background-color': item.color, 'color': item.textColor}">
                            {{ item.label | translate }}
                          </span>
                        </button>
                      }
                    </mat-menu>
                  } @else {
                    <button type="button" class="batch-action-btn" [ngClass]="action.class"
                      [disabled]="action.disabled || !action.onClick" (click)="action.onClick && action.onClick()">
                      @if (action.matIcon) {
                        <mat-icon>{{ action.matIcon }}</mat-icon>
                      }
                      @if (action.iconClass) {
                        <i [class]="action.iconClass"></i>
                      }
                      <span>{{ action.label | translate }}</span>
                    </button>
                  }
                }
              }
              <button type="button" class="batch-clear-btn" (click)="clearRowSelection()"
                [title]="'Clear selection' | translate">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        }
        @if (isGridViewEnabled && !isLoading && canRead) {
          <div class="sort-field-row d-flex align-items-center justify-content-between mt-2"
            >
            <ng-container *ngTemplateOutlet="filterAndViewControls; context: { compact: false }"></ng-container>
          </div>
        }
        <ng-container *ngTemplateOutlet="gridContent"></ng-container>
      </app-sidebar-layout>
    }

    <!-- Normal mode: Include sidebar layout -->
  </div>

  <!-- Shared filter chips, view selector, and grid settings template -->
  <ng-template #filterAndViewControls let-compact="compact">
    @if (showFilterControls) {
    <div class="active-filters-display d-flex align-items-center" [class.ml-2]="!compact">
      @if (!currentFilters.length && !drillDownFilterChips.length && !activeQuickFilters.length) {
        <span class="no-filters-message" [style.font-size]="compact ? '0.9em' : null">{{'No filters currently
        active' | translate}}</span>
      }
      @for (filter of currentFilters; track filter) {
        <div class="filter-chip" [ngClass]="{'active': activeGridFilters[filter.column.property] !== false}"
          (click)="onFilterChipClick(filter)" [title]="gridSettingsService.getDisplayValue(filter)">
          <i class="{{ gridSettingsService.getColumnTypeIcon(filter) }} filter-type-icon"></i>
          <span class="filter-column">{{ columnDisplayNames[filter.column.property] | translate}}:</span>
          <span class="filter-value">{{ gridSettingsService.getDisplayValue(filter) }}</span>
          <button class="remove-filter-btn" (click)="removeCurrentFilter(filter); $event.stopPropagation();"
            [title]="'Remove filter' | translate">
            <i class="fa fa-times my-1"></i>
          </button>
        </div>
      }
      @for (chip of drillDownFilterChips; track chip.key) {
        <div class="filter-chip active" [title]="chip.label | translate">
          <i class="fa fa-check filter-type-icon"></i>
          <span class="filter-value">{{ chip.label | translate }}</span>
          <button class="remove-filter-btn" (click)="removeDrillDownFilter(chip)" [title]="'Remove filter' | translate">
            <i class="fa fa-times my-1"></i>
          </button>
        </div>
      }
      @for (quickFilter of activeQuickFilters; track quickFilter.key) {
        <div class="filter-chip active" [title]="quickFilter.label | translate">
          <i class="fa fa-check filter-type-icon"></i>
          <span class="filter-value">{{ quickFilter.label | translate }}</span>
          <button class="remove-filter-btn" (click)="onQuickFilterToggled(quickFilter.key, false)" [title]="'Remove filter' | translate">
            <i class="fa fa-times my-1"></i>
          </button>
        </div>
      }
      <button class="add-filter-btn ml-2" type="button" (click)="openGridSettingsFlyout('filters')"
        [style.font-size]="compact ? '0.9em' : null">
        <span class="plus">+</span> <span class="label">{{'Filter' | translate}}</span>
      </button>
    </div>
    }
    @if (toolbarComponent && !isDialog) {
      <ng-container *ngComponentOutlet="toolbarComponent"></ng-container>
    }
    <div class="d-flex align-items-center ml-auto">
      @if (selectedOrg?.id && showFilterControls) {
        <div class="sort-field table-view-selector">
          <app-table-view-selector [objectId]="objectId" [gridId]="gridId" [defaultViewId]="defaultGridViewId"
            [selectedViewId]="currentSelectedViewId" [refreshViews$]="refreshViews$"
            (viewsChanged)="onViewsChanged($event)" [orgLevelId]="$safeNavigationMigration(selectedOrg?.id)" [canSaveView]="canSaveView"
            [isTemporaryView]="isTemporaryView || hasUnsavedViewChanges"
            (addView)="onAddView($event)" (viewSelected)="onViewSelected($event.view, $event.firstRender)">
          </app-table-view-selector>
        </div>
      }
      <div class="sort-field grid-settings" [class.ml-2]="compact">
        <button type="button" class="btn" [title]="'Grid settings' | translate" [disabled]="!selectedOrg?.id"
          (click)="openGridSettingsFlyout()">
          <img src="assets/images/grid-settings.svg" alt="grid settings" class="grid-settings-icon" />
        </button>
      </div>
      <div class="sort-field grid-export">
        @if (extraExportOptions.length === 0) {
          <button type="button" class="btn export-btn"
            [title]="(exportDisabledReason ?? 'Export Data') | translate" [disabled]="!selectedOrg?.id || isLoading || !!exportDisabledReason" (click)="exportToExcel()">
            <span class="material-symbols-outlined export-icon">download</span>
            {{ 'Export' | translate }}
          </button>
        } @else {
          <button type="button" class="btn export-btn" [title]="(exportDisabledReason ?? 'Export Data') | translate"
            [disabled]="!selectedOrg?.id || isLoading || !!exportDisabledReason" [matMenuTriggerFor]="exportOptionsMenu">
            <span class="material-symbols-outlined export-icon">download</span>
            {{ 'Export' | translate }}
          </button>
          <mat-menu #exportOptionsMenu="matMenu">
            <button mat-menu-item type="button" (click)="exportToExcel()">{{ 'Export' | translate }}</button>
            @for (option of extraExportOptions; track trackByIndex($index)) {
              <button mat-menu-item type="button"
                [disabled]="option.disabled" (click)="option.onClick()">
                {{ option.label | translate }}
              </button>
            }
          </mat-menu>
        }
      </div>
    </div>
  </ng-template>

  <!-- Grid content template (shared between widget mode and normal mode) -->
  <ng-template #gridContent>
    <section class="card-style-sec d-flex"
      [ngClass]="{'disabled-content': !canRead, 'no-overview': !showOverview, 'widget-grid-section': widgetMode}"
      [ngStyle]="{ '--overview-width': showOverview ? overviewWidth : '0%' }">
      <div class="custom-theme-table tableColStyle without-borders-table">
        @if (isLoading) {
          <div class="grid-loading-overlay">
            <app-rings-loader></app-rings-loader>
          </div>
        }
        <div class="table-responsive custom-scrollbar">

          @if (shouldShowNoColumnsMessage()) {
            <div class="no-columns-configured">
              <img src="assets/images/no-columns-placeholder.webp" alt="No columns" />
              <h3 class="no-columns-title">{{"Configure your columns" | translate}}</h3>
              <p class="no-columns-desc">{{"You haven't configured any columns yet. Add fields as columns to
              see search results and their information" | translate}}</p>
            </div>
          }

          <table [class.hide-table]="shouldShowNoColumnsMessage()"
            [class.has-frozen-columns]="frozenColumnCount > 0" [attr.data-grid-id]="gridId" mat-table
            class="table table-stripes" [dataSource]="hasRowTree ? treeRows : dataSource" [trackBy]="trackById" matSort [matSortDirection]="defaultOrderBy"
            [matSortActive]="sortActive" matSortDisableClear (matSortChange)="onSortChangedFromTable($event)">

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                @if (isLoading) {
                  <ng-container class="loader-container">
                    <app-rings-loader></app-rings-loader>
                  </ng-container>
                }
                @if (!isLoading) {
                  @if (canRead) {
                    {{'No data matching the filter' | translate}}
                  }
                  @if (!canRead) {
                    {{ 'You do not have permission to view' | translate: { addEntityTitle:
                    addEntityTitle } }}
                  }
                }
              </td>
            </tr>

            @for (column of columnConfigs; track column) {
              @if (column.name !== actionColumnProperty) {
                <ng-container [matColumnDef]="column.name">
                  <th mat-header-cell *matHeaderCellDef [attr.data-col-name]="column.name"
                    [attr.data-field]="column.name"
                    [attr.data-col-configurable]="column.isDisplayNameConfigurable"
                    [class]="headerClassByColumn[column.name]" [style.left]="columnFrozenMeta[column.name]?.leftPx"
                    [class.frozen-column]="columnFrozenMeta[column.name]?.frozen"
                    [class.frozen-column-last]="columnFrozenMeta[column.name]?.isLast"
                    (click)="onHeaderCellClicked(column)">
                    <div class="header-content">
                      @if (columnFrozenMeta[column.name]?.showIndicator) {
                        <mat-icon
                        class="frozen-indicator-icon">ac_unit</mat-icon>
                      }
                      @if (column.isSortable) {
                        <span mat-sort-header>
                          {{ columnDisplayNames[column.name] | translate }}
                          <mat-icon class="sort-indicator" [class.sort-active]="sortActive === column.name">{{ sortActive === column.name ? (defaultOrderBy === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}</mat-icon>
                        </span>
                      } @else {
                        <span>{{ columnDisplayNames[column.name] | translate}}</span>
                      }
                      @if (isGridViewEnabled && showFilterControls && column.isDisplayNameConfigurable !== false && !widgetMode) {
                        <button
                          type="button" class="column-filter-icon"
                          [class.filter-active]="activeGridFilters[column.name]"
                          [disabled]="!columnFilterableByName[column.name]"
                          (click)="openFilterForColumn(column.name); $event.stopPropagation();"
                          [title]="columnFilterableByName[column.name] ? (('Filter' | translate) +' '+ (columnDisplayNames[column.name] | translate)) : ('Filtering not available' | translate)">
                          <img src="assets/images/filter.svg" alt="Filters Icon" class="icon" />
                        </button>
                      }
                    </div>
                    @if (column.headerChildren) {
                      @for (child of column.headerChildren(); track trackByIndex($index)) {
                        <ng-container
                        *ngTemplateOutlet="childRenderer; context: { child: child, row: null }"></ng-container>
                      }
                    }
                  </th>
                  <td mat-cell *matCellDef="let row" [class]="getDataCellClass(column, row)"
                    [attr.data-col-name]="column.name"
                    [style.left]="columnFrozenMeta[column.name]?.leftPx"
                    [class.frozen-column]="columnFrozenMeta[column.name]?.frozen"
                    [class.frozen-column-last]="columnFrozenMeta[column.name]?.isLast"
                    (click)="onCellClicked(column, row, $event)">
                    @if (hasRowTree && column.name === treeColumnName) {
                      <span class="row-tree-toggle" [style.padding-left.px]="(rowTreeMeta[row.id]?.depth ?? 0) * 20">
                        @if (rowTreeMeta[row.id]?.expandable) {
                          <mat-icon class="row-tree-chevron">{{ rowTreeMeta[row.id].expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                        } @else {
                          <span class="row-tree-spacer"></span>
                        }
                      </span>
                    }
                    @if (column.cellTemplate) {
                      <span [class]="column.textCssClass ? column.textCssClass(row) : ''"
                      [innerHTML]="column.cellTemplate(row)"></span>
                      <!-- A cell can show the same icon more than once, so its icons are tracked by position. -->
                      @if (column.imgSrcs) {
                        @for (src of column.imgSrcs(row); track $index; let i = $index) {
                          <img [src]="src"
                            matTooltipPosition="above"
                            [matTooltip]="column.imgTooltips ? column.imgTooltips(row)[i] : ''">
                        }
                      }
                      @if (column.iconCssClass) {
                        <i [class]="column.iconCssClass(row)"></i>
                      }
                    } @else {
                      @if (column.imgSrcs) {
                        @for (src of column.imgSrcs(row); track $index; let i = $index) {
                          <img [src]="src"
                            matTooltipPosition="above"
                            [matTooltip]="column.imgTooltips ? column.imgTooltips(row)[i] : ''">
                        }
                      }
                      @if (column.iconCssClass) {
                        <i [class]="column.iconCssClass(row)"></i>
                      }
                      {{ row[column.name] }}
                    }
                    @if (column.children) {
                      @if (column.childrenInline) {
                        <span class="cell-children" [class.cell-children-inline]="column.childrenInline(row)">
                          @for (child of column.children(row); track trackByIndex($index)) {
                            <ng-container
                            *ngTemplateOutlet="childRenderer; context: { child: child, row: row }"></ng-container>
                          }
                        </span>
                      } @else {
                        @for (child of column.children(row); track trackByIndex($index)) {
                          <ng-container
                          *ngTemplateOutlet="childRenderer; context: { child: child, row: row }"></ng-container>
                        }
                      }
                    }
                  </td>
                </ng-container>
              }
            }

            <ng-container matColumnDef="action">
              <th class="action-column" mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="action-row">
                  @if (canUpdate && !editDisabled && !widgetMode) {
                    <i
                      title="{{'Update' | translate}}"
                      class="material-icons cursor-pointer material-grey-icon big-icon"
                    (click)="$event.stopPropagation(); openEntityDialog(row.id)">edit</i>
                  }

                  @if (canDelete && !deleteDisabled && !widgetMode) {
                    <i
                      title="{{deleteActionLabel | translate}}"
                      class="material-icons cursor-pointer material-grey-icon big-icon"
                    (click)="$event.stopPropagation(); openEntityDeleteDialog(row)">{{deleteActionIcon}}</i>
                  }

                  @for (action of additionalActions; track action) {
                    @if (!widgetMode && !(action.hidden && action.hidden(row))) {
                      <mat-icon class="cursor-pointer"
                        [class.disabled]="action.disabled && action.disabled(row)"
                        [title]="action.name | translate" (click)="onAdditionalActionClicked(action, row, $event)">
                        <i class="{{ action.icon }} action-icon"></i>
                      </mat-icon>
                    }
                  }

                  @if (rowActionMenu && !widgetMode) {
                    <button type="button" mat-icon-button class="row-action-menu-trigger"
                      [matMenuTriggerFor]="rowActionMenu_menu" [matMenuTriggerData]="{ row: row }"
                      [matTooltip]="'Options' | translate" (click)="$event.stopPropagation()"
                      (keydown.enter)="$event.stopPropagation()">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                </div>
              </td>
            </ng-container>

            <mat-menu #rowActionMenu_menu="matMenu" [class]="rowActionMenuPanelClass">
              <ng-template matMenuContent let-row="row">
                @for (item of rowActionMenu!(row); track trackByIndex($index)) {
                  @if (!item.hidden) {
                    @if (item.dividerBefore) {
                      <mat-divider></mat-divider>
                    }
                    <button type="button" mat-menu-item
                      [disabled]="item.disabled"
                      [matTooltip]="item.tooltip ? (item.tooltip | translate) : ''"
                      [ngClass]="{ 'red-text': item.danger }"
                      (click)="item.action(row)">
                      <mat-icon>{{ item.icon }}</mat-icon>
                      <span>{{ item.label | translate }}</span>
                    </button>
                  }
                }
              </ng-template>
            </mat-menu>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; let even = even;
                            columns: displayedColumns;" [class.even-row]="even"
              [class.clickable-row]="hasRowClickAction"
              [attr.tabindex]="hasRowClickAction ? 0 : null"
              (click)="!widgetMode && onRowClicked(row)"
              (keydown.enter)="hasRowClickAction && onRowClicked(row)"
              [class.selected-search-row]="isDialog && isSearchRowSelected(row)">
            </tr>

          </table>
        </div>
        <div class="paginator-container">
          @if (totalItems > 0) {
            <span class="pagination-label">
              {{ 'Displaying' | translate }} {{ displayStart }}-{{ displayEnd }} {{ 'of' | translate }} {{ totalItems }}
            </span>
          }
          <mat-paginator [length]="$safeNavigationMigration(dataSource?.count$) | async" [pageSizeOptions]="pageSizeOptions"
          [pageSize]="pageSize" [selectConfig]="pageSizeSelectConfig"></mat-paginator>
        </div>
      </div>

      @if (showOverview) {
        <div class="overview-container">
          @if (isOverviewLoading) {
            <div class="loader-container">
              <app-rings-loader></app-rings-loader>
            </div>
          }
          @if (!isOverviewLoading) {
            <div class="ttl">
              <span>{{ addEntityTitle }} {{'Overview' | translate}}</span>
            </div>
            <div class="items-container">
              @for (item of overviewConfigs; track item) {
                <div class="overview-box"
                  [ngClass]="{ 'active-filter': activeFilters.has(item.id) }"
                  (click)="toggleFilter(item.id, item.onClick)">
                  <div class="overview-title">{{ item.title | translate }}</div>
                  <div class="overview-value">{{ item.value }}</div>
                </div>
              }
            </div>
          }
        </div>
      }

    </section>
  </ng-template>

  <ng-template #childRenderer let-child="child" let-row="row">
    @if (child) {
      <span
        [class]="child.cssClass ? child.cssClass(row) + (child.readonly && child.readonly(row) ? ' disabled' : '') : (child.readonly && child.readonly(row) ? 'disabled' : '')"
        (click)="onChildClicked(child, row, $event)"
        [matTooltip]="child.tooltip ? child.tooltip(row) : ''" matTooltipPosition="above">
        @if (child.cellTemplate) {
          <span [class]="child.textCssClass ? child.textCssClass(row) : ''" [innerHTML]="child.cellTemplate(row)">
          </span>
          <!-- A cell can show the same icon more than once, so its icons are tracked by position. -->
          @if (child.imgSrcs) {
            @for (src of child.imgSrcs(row); track $index; let i = $index) {
              <img [src]="src" matTooltipPosition="above"
                [matTooltip]="child.imgTooltips ? child.imgTooltips(row)[i] : ''">
            }
          }
        } @else {
          @if (child.imgSrcs) {
            @for (src of child.imgSrcs(row); track $index; let i = $index) {
              <img [src]="src" matTooltipPosition="above"
                [matTooltip]="child.imgTooltips ? child.imgTooltips(row)[i] : ''">
            }
          }
          @if (child.iconCssClass) {
            <i [class]="child.iconCssClass(row)"> </i>
          }
        }
      </span>
    }
  </ng-template>

  <app-flyout-container #flyout></app-flyout-container>

  @if (isGridSettingsFlyoutOpen && isGridViewEnabled && canRead) {
    <app-grid-settings-flyout class="grid-settings-flyout"
      [gridViewColumns]="gridViewColumns" [title]="gridViewTitle" [selectedGridView]="selectedGridView"
      [selectedSort]="currentSort" [filters]="filters" [quickFilters]="quickFilters" [quickFilterValues]="quickFilterValues"
      [activeTab]="gridSettingsFlyoutTab"
      [preSelectedColumnProperty]="preSelectedFilterColumn" [getColumnDisplayName]="getColumnDisplayName.bind(this)"
      [actionColumnProperty]="actionColumnProperty" [canSaveView]="canSaveView" [gridId]="gridId"
      [ngStyle]="{ '--overview-width': overviewWidth }" (close)="onGridSettingsFlyoutClose($event)"
      (columnsChanged)="onGridSettingsColumnsChanged($event)" (filtersChanged)="onFiltersChanged($event)"
      (quickFilterToggled)="onQuickFilterToggled($event.key, $event.isOn)" (sortChanged)="onSortChangedFromFlyout($event)" (frozenColumnsChanged)="onFrozenColumnsChanged($event)">
    </app-grid-settings-flyout>
  }
